<script>
  import ClickOut from '../../../../utils/directives/clickout'

  export default{
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      clicked: function (e) {
        console.log('prevented!')
        e.preventDefault()
      }
    },
    directives: {ClickOut}
  }
</script>

<template>
  <li :class="{ active: open }">
    <a v-click-out="hide" @click="toggle" class="auto">
      <span class="pull-right text-muted">
      <i class="fa fa-fw fa-angle-right text"></i>
      <i class="fa fa-fw fa-angle-down text-active"></i>
      </span>
      <i class="icon-screen-desktop icon "></i>
      <span>Website</span>
    </a>
    <ul class="nav nav-sub dk">
      <li class="nav-sub-header"><a><span class="text-muted teste">Website</span></a></li>
      <!--<li><a><span>Dashboard</span></a></li>-->
      <!--<li>
        <router-link :to="{ name: 'arrematantes' }"><span>Arrematantes</span></router-link>
      </li>-->
      <!--<li>
        <router-link :to="{ name: 'comitentes' }"><span>Comitentes</span></router-link>
      </li>-->
      <!--<router-link :to="{ name: 'leilao' }" tag="li"><a><span>Leilões</span></a></router-link>-->
      <!--<li>
        <router-link :to="{ name: 'contatos' }"><span>Atendimento</span></router-link>
      </li>-->
      <li>
        <router-link :to="{ name: 'banners.lista' }"><span>Banners</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'popup.lista' }"><span>Pop-up</span></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'eventos' }"><span>Eventos</span></router-link>
      </li>
      <!--<li>
        <router-link :to="{ name: 'documentos' }"><span>Documentos</span></router-link>
      </li>-->
      <!--<li><a><span>Relatórios</span></a></li>
      <li><a><span>Configurações</span></a></li>-->
    </ul>
  </li>
</template>



// WEBPACK FOOTER //
// AdminSite.vue?2985107c